export default __webpack_public_path__ + "assets/images/3b417e934ff8896c43571c0c614f3287.png";